import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme =>
  createStyles({
    rowContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
      marginTop: theme.spacing(2),
      padding: theme.spacing(1),
    },
    container: {
      alignSelf: 'center',
      flex: 1,
      boxSizing: 'border-box',
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(6, 10),
        maxWidth: '70%',
      },
      [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(6, 12),
        maxWidth: '800px',
      },
    },
    footer: {
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(2),
      justifyContent: 'flex-end',
      padding: theme.spacing(2, 0),
    },
    label: {
      color: theme.palette.common.black,
      fontSize: '0.875rem',
      fontWeight: theme.typography.h4.fontWeight,
    },
    subtitle: {
      marginTop: theme.spacing(3),
    },
    textField: {
      padding: theme.spacing(2, 0),
    },
    backToSettings: {
      marginBottom: theme.spacing(1),
      '& a': {
        color: theme.palette.grey[500],
        '&:visited': {
          color: theme.palette.grey[500],
        },
      },
    },
    leftArrow: {
      marginRight: theme.spacing(1),
    },
  }),
);
